import {
  BatchSelectionHeader,
  formatDownloadUnmatchedEOB,
  formatDownloadUnSupportedFax,
  FormatStatus,
  FormatTime,
  getCount,
} from 'features/autocheck/utils'
import { UpgradeBatch } from 'features/autocheck/utils/BatchUpgrade'
import { formatCancelRequest, formatStopProcessing } from 'features/autocheck/utils/CancelBatch'
import { formatBatchDetails } from 'features/autocheck/utils/ColumnFormatter/batchResults'
import {
  formatActionCheckProgress,
  formatDeliveryWindow,
  formatEOBReceived,
} from 'features/autocheck/utils/EOBReceived'
import { filterParams } from 'features/autocheck/utils/grid'
import moment from 'moment'

export const EobReviewConfig = [
  {
    field: 'unmatchedDate',
    headerName: 'Date Received',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return moment(params.value).utc().format('MM/DD/YYYY')
    },
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: ['lessThan', 'greaterThan', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'unmatchedEOBCount',
    headerName: 'Number of EOBs',
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['lessThanOrEqual', 'greaterThanOrEqual', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'fileName',
    headerName: 'File Name',
    resizable: true,
    width: 250,
  },
  {
    field: '',
    headerName: '',
    width: 210,
    pinned: 'right',
    cellRenderer: formatDownloadUnmatchedEOB,
    cellStyle: { overflow: 'visible' },
    colId: 'upgradeBatch',
  },
]

export const UnSupportedFaxReviewConfig = [
  {
    field: 'dateReceived',
    headerName: 'Date Received',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return moment(params.value).utc().format('MM/DD/YYYY')
    },
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: ['lessThan', 'greaterThan', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'unsupportedEOBCount',
    headerName: 'Number of Faxes',
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['lessThanOrEqual', 'greaterThanOrEqual', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'fileName',
    headerName: 'File Name',
    resizable: true,
    width: 250,
  },
  {
    field: '',
    headerName: '',
    width: 210,
    pinned: 'right',
    cellRenderer: formatDownloadUnSupportedFax,
    cellStyle: { overflow: 'visible' },
    colId: 'upgradeBatch',
  },
]

export const BatchClaimFilesConfig = [
  {
    field: 'batchName',
    headerName: 'File Name',
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
    sortable: true,
    width: 250,
  },
  {
    field: 'batchCode',
    headerName: 'Batch ID',
    sortable: true,
    width: 110,
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      buttons: ['apply', 'cancel'],
    },
  },
  {
    field: 'batchCount',
    headerName: 'Pending',
    width: 150,
    valueFormatter: (params: any) => {
      return getCount(params) + ' Claims'
    },
  },
  {
    field: 'uploaderUserName',
    headerName: 'Uploaded By',
    width: 150,
    filter: 'agSetColumnFilter',
    filterParams: filterParams,
  },
  {
    field: 'created',
    headerName: 'Uploaded Date & Time',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
    sortable: true,
  },
  {
    field: '',
    headerName: '',
    width: 150,
    pinned: 'right',
    cellRenderer: formatBatchDetails,
  },
  {
    field: '',
    headerName: '',
    width: 150,
    pinned: 'right',
    cellRenderer: formatCancelRequest,
  },
  {
    field: '',
    headerName: '',
    width: 150,
    pinned: 'right',
    cellRenderer: UpgradeBatch,
    colId: 'upgradeBatch',
  },
]

export const BatchAwaitingEOBConfig = [
  {
    field: 'batchName',
    headerName: 'File Name',
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
    sortable: true,
    width: 250,
  },
  {
    field: 'batchCode',
    headerName: 'Batch ID',
    sortable: true,
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      buttons: ['apply', 'cancel'],
    },
  },
  {
    field: 'statusAcquired',
    headerName: 'Statuses Acquired',
    cellRenderer: formatActionCheckProgress,
  },
  {
    field: 'lastUpdatedTime',
    headerName: 'Processed Date & Time',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
  },
  {
    field: 'eobReceivedCount',
    headerName: 'EOBs Received',
    cellRenderer: formatEOBReceived,
  },
  {
    field: 'Delivery Window',
    headerName: 'Delivery Window',
    cellRenderer: formatDeliveryWindow,
  },
  {
    field: 'uploaderUserName',
    headerName: 'Uploaded By',
    width: 180,
    filterParams: filterParams,
    filter: 'agSetColumnFilter',
  },
  {
    field: '',
    headerName: '',
    cellRenderer: formatBatchDetails,
    pinned: 'right',
  },
]

export const BatchGridProcessingConfig = [
  {
    field: 'batchName',
    headerName: 'File Name',
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
    sortable: true,
    width: 250,
  },
  {
    field: 'batchCode',
    headerName: 'Batch ID',
    width: 110,
    sortable: true,
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      buttons: ['apply', 'cancel'],
    },
  },
  {
    field: 'status',
    headerName: 'Batch Status',
    width: 150,
    cellRenderer: (params: { value: string }) => FormatStatus(params.value),
  },
  {
    field: 'batchCount',
    headerName: 'Checking Status',
    width: 150,
    valueFormatter: (params: any) => {
      return getCount(params) + ' Claims'
    },
  },
  {
    field: 'statusAcquired',
    headerName: 'Statuses Acquired',
    width: 200,
    cellRenderer: formatActionCheckProgress,
  },
  {
    field: 'uploaderUserName',
    headerName: 'Uploaded By',
    width: 180,
    filter: 'agSetColumnFilter',
    filterParams: filterParams,
  },
  {
    field: 'created',
    headerName: 'Upload Date & Time',
    width: 260,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
  },
  {
    field: '',
    headerName: '',
    width: 150,
    pinned: 'right',
    cellRenderer: formatStopProcessing,
  },
  {
    field: '',
    headerName: '',
    width: 180,
    pinned: 'right',
    cellRenderer: formatBatchDetails,
  },
]

export const BatchGridProcessdConfig = [
  {
    field: '',
    headerName: '',
    width: 50,
    checkboxSelection: true,
    headerCheckboxSelection: false,
    showDisabledCheckboxes: true,
    headerComponent: BatchSelectionHeader,
    resisable: true,
  },
  {
    field: 'batchName',
    headerName: 'File Name',
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
    sortable: true,
    width: 250,
  },
  {
    field: 'status',
    headerName: 'Batch Status',
    cellRenderer: (params: { value: string }) => FormatStatus(params.value),
    sortable: true,
  },
  {
    field: 'batchCode',
    headerName: 'Batch ID',
    sortable: true,
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      buttons: ['apply', 'cancel'],
    },
  },

  {
    field: 'statusAcquired',
    headerName: 'Statuses Acquired',
    cellRenderer: formatActionCheckProgress,
    sortable: true,
  },
  /*{
    field: 'EOBs Received',
    headerName: 'EOBs Received',
    valueFormatter: (params: any) => {
      return params.data.batchType === BatchType.Claim_Autocheck_EOB ? 'WIP' : 'N/A'
    },
  },*/
  {
    field: 'eobReceivedCount',
    headerName: 'EOBs Received',
    cellRenderer: formatEOBReceived,
    sortable: true,
  },
  {
    field: 'updated',
    headerName: 'Finish Date & Time',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: ['lessThan', 'greaterThan', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'uploaderUserName',
    headerName: 'Uploaded By',
    filter: 'agSetColumnFilter',
    filterParams: filterParams,
  },
  {
    field: '',
    headerName: '',
    cellRenderer: formatBatchDetails,
    pinned: 'right',
  },
]

export const BatchGridArchivedConfig = [
  {
    field: '',
    headerName: '',
    width: 50,
    checkboxSelection: true,
    headerCheckboxSelection: false,
    showDisabledCheckboxes: true,
    headerComponent: BatchSelectionHeader,
  },
  {
    field: 'batchName',
    headerName: 'File Name',
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
    sortable: true,
    width: 250,
  },
  {
    field: 'status',
    headerName: 'Batch Status',
    cellRenderer: (params: { value: string }) => FormatStatus(params.value),
    sortable: true,
  },
  {
    field: 'batchCode',
    headerName: 'Batch ID',
    sortable: true,
    filter: 'agNumberColumnFilter',
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      buttons: ['apply', 'cancel'],
    },
  },

  {
    field: 'statusAcquired',
    headerName: 'Status Acquired',
    cellRenderer: formatActionCheckProgress,
    sortable: true,
  },
  /*{
    field: 'EOBs Received',
    headerName: 'EOBs Received',
    valueFormatter: (params: any) => {
      return params.data.batchType === BatchType.Claim_Autocheck_EOB ? 'WIP' : 'N/A'
    },
  },*/
  {
    field: 'eobReceivedCount',
    headerName: 'EOBs Received',
    cellRenderer: formatEOBReceived,
    sortable: true,
  },
  {
    field: 'lastUpdatedTime',
    headerName: 'Finish Date & Time',
    width: 250,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: ['lessThan', 'greaterThan', 'inRange'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'cancel'],
      closeOnApply: true,
    },
  },
  {
    field: 'uploaderUserName',
    headerName: 'Uploaded By',
    filter: 'agSetColumnFilter',
    filterParams: filterParams,
  },
]
